/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ClothesShoesHighheelsIcon16Light } from './ClothesShoesHighheelsIcon16Light';
import { ClothesShoesHighheelsIcon16Regular } from './ClothesShoesHighheelsIcon16Regular';
import { ClothesShoesHighheelsIcon16Solid } from './ClothesShoesHighheelsIcon16Solid';
import { ClothesShoesHighheelsIcon20Light } from './ClothesShoesHighheelsIcon20Light';
import { ClothesShoesHighheelsIcon20Regular } from './ClothesShoesHighheelsIcon20Regular';
import { ClothesShoesHighheelsIcon20Solid } from './ClothesShoesHighheelsIcon20Solid';
import { ClothesShoesHighheelsIcon24Regular } from './ClothesShoesHighheelsIcon24Regular';
import { ClothesShoesHighheelsIcon24Solid } from './ClothesShoesHighheelsIcon24Solid';
import { ClothesShoesHighheelsIcon32Regular } from './ClothesShoesHighheelsIcon32Regular';
import { ClothesShoesHighheelsIcon64Regular } from './ClothesShoesHighheelsIcon64Regular';
var sizes = {
    16: {
        light: ClothesShoesHighheelsIcon16Light,
        regular: ClothesShoesHighheelsIcon16Regular,
        solid: ClothesShoesHighheelsIcon16Solid,
    },
    20: {
        light: ClothesShoesHighheelsIcon20Light,
        regular: ClothesShoesHighheelsIcon20Regular,
        solid: ClothesShoesHighheelsIcon20Solid,
    },
    24: {
        regular: ClothesShoesHighheelsIcon24Regular,
        solid: ClothesShoesHighheelsIcon24Solid,
    },
    32: {
        regular: ClothesShoesHighheelsIcon32Regular,
    },
    64: {
        regular: ClothesShoesHighheelsIcon64Regular,
    },
};
export var ClothesShoesHighheelsIcon = forwardRef('ClothesShoesHighheelsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
